import { takeEvery } from 'redux-saga/effects';
import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';
import { transferToQueueRequest } from '../api/transferToQueue';
import { transferToQueueModalRequest, transferToQueueModalRequestFailed, transferToQueueModalRequestSucceeded, } from '../reducers/transferToQueueModal';
export const transferToQueueModal = [
    takeEvery(transferToQueueModalRequest.toString(), sagaApiGenWithPromise(transferToQueueRequest, transferToQueueModalRequestSucceeded, transferToQueueModalRequestFailed)),
];
